// controls the state of the display of the product card and chooses which one to display
import React from "react";
import { Col } from "antd";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import AddCard from "./NewCard";
import DisplayCard from "./DisplayCard";

const productCounts = {};
[1, 2, 2, 3].forEach((value, i) => {
	productCounts[i] = value;
});

const ProductCard = ({ productCount, setProductCount, setEditModes, product, add = false }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: product?.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    height: "100%",
  }
  
  return (
    <Col span={24 / productCounts[productCount]} style={{ height: "100%" }}>
      {add ? (
        <AddCard setProductCount={setProductCount} setEditModes={setEditModes} />
      ) : (
        <div style={style} {...attributes} {...listeners} ref={setNodeRef}>
          <DisplayCard product={product} setProductCount={setProductCount} />
        </div>
      )}
    </Col>
	);
};

export default ProductCard;